<!--
  - SPDX-FileCopyrightText: 2022 Nextcloud GmbH and Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->
<template>
	<!-- Errors handlers-->
	<NcEmptyContent v-if="error" :name="t('photos', 'An error occurred') ">
		<AlertCircle slot="icon" />
	</NcEmptyContent>

	<div v-else class="collections">
		<!-- Collection header -->
		<slot name="header" />

		<!-- No collections -->
		<slot v-if="noCollection && !loading" name="empty-collections-list" class="collections__empty" />

		<!-- List -->
		<ul v-else-if="!noCollection" class="collections__list">
			<slot v-for="collection in collections"
				:collection="collection"
				class="collection" />
		</ul>
	</div>
</template>

<script>
import AlertCircle from 'vue-material-design-icons/AlertCircle.vue'

import { NcEmptyContent } from '@nextcloud/vue'
import { translate } from '@nextcloud/l10n'

export default {
	name: 'CollectionsList',

	components: {
		AlertCircle,
		NcEmptyContent,
	},

	props: {
		/** @type {import('vue').PropType<import('../../services/collectionFetcher').IndexedCollections>} */
		collections: {
			type: Object,
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		error: {
			type: Error,
			default: null,
		},
	},

	computed: {
		/**
		 * @return {boolean} Whether the list of collections is empty or not.
		 */
		noCollection() {
			return Object.keys(this.collections).length === 0
		},
	},

	methods: {
		t: translate,
	},
}
</script>
<style lang="scss" scoped>
.collections {
	display: flex;
	flex-direction: column;
	height: 100%;

	&__list {
		padding: 32px 48px;
		flex-grow: 1;
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
		align-items: flex-start;
		height: calc(100% - 60px);
		overflow-x: scroll;

		@media only screen and (max-width: 1200px) {
			padding: 32px 12px;
			justify-content: center;
		}
	}
}
</style>
